import { IoHomeOutline } from 'react-icons/io5';
import { IoPersonOutline } from 'react-icons/io5';
import { IoBriefcaseOutline } from 'react-icons/io5';
import { IoMailOutline } from 'react-icons/io5';

const data = [
  { id: 1, link: '#home', title: 'Home', icon: <IoHomeOutline /> },
  { id: 2, link: '#about', title: 'About', icon: <IoPersonOutline /> },
  {
    id: 3,
    link: '#portfolio',
    title: 'Portfolio',
    icon: <IoBriefcaseOutline />,
  },
  { id: 4, link: '#contact', title: 'Contact', icon: <IoMailOutline /> },
];

export default data;
